module.exports = require('lodash').reduce